import * as Yup from 'yup'
export function insertvalidations(values) {
    return Yup.object().shape({
        trade_order: Yup.string().required('This field is required'),
        trade_position: Yup.string().required('This field is required'),
        trade_option: Yup.string().required('This field is required'),
        trade_commodity: Yup.string().required('This field is required'),
        trade_contract: Yup.string().required('This field is required'),
    });
}
